import React from "react";
import camelToTitleCase from "../../../../../../utils/camelToTitleCase";

export default function Card({ header, data }) {
  console.log(data);

  return (
    <div className="rounded-bottom" style={{ background: "white" }}>
      <div className=" bg-primary p-4 rounded-top">
        <div className="text-white fw-semibold">
          <p className="m-0 p-0" style={{ fontSize: "1.1rem" }}>
            {header}
          </p>
        </div>
      </div>
      <div className="p-4">
        {data.map((item) => {
          return (
            <div className="d-flex align-items-center w-50 gap-1 mb-2">
              <div className="" style={{ flex: 1 }}>
                <p className="m-0">{camelToTitleCase(item?.label)}: </p>
              </div>
              <div className="" style={{ flex: 1 }}>
                <p className="m-0 fw-medium text-primary">{item?.value}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
